import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmModalComponent } from './confirm-modal.component';

@NgModule({
    declarations: [ConfirmModalComponent],
    exports: [ConfirmModalComponent],
    imports: [MatDialogModule, MatButtonModule],
})
export class ConfirmModalModule {}
